export const server = {
  API_URL: "https://backendbutiko.com/api/",
  //API_URL: "http://127.0.0.1:8000/api/",
  // API_URL: "https://enviossendiback.azurewebsites.net/api/",
};
export const directionUsa = {
  nombre: "“Tu nombre”",
  direccion: "11751 SW 103RD LN CODE 169",
  ciudad: "MIAMI",
  estado: "FLORIDA",
  codigoPostal: "33186",
  pais: "UNITED STATES",
  telefono: "19998887777",
};

// Mapea la respuesta de `client/legacy/locker` a un objeto `direction`
// con fallback por-campo a `directionUsa` cuando el servicio no devuelve el dato.
export function mapLegacyDirection(resp) {
  const body = resp?.data?.body ?? {};
  const data = body?.legacy?.data ?? {};
  const [ciudad, estado] = String(data.c_city ?? "")
    .split(",")
    .map((s) => s.trim());
  return {
    locker: body.locker ?? data.locker ?? null,
    direction: {
      nombre: directionUsa.nombre, // el servicio no lo devuelve
      direccion: data.locker_address ?? directionUsa.direccion,
      ciudad: ciudad || directionUsa.ciudad,
      estado: estado || directionUsa.estado,
      codigoPostal: data.c_postal ?? directionUsa.codigoPostal,
      pais: data.c_country ?? directionUsa.pais,
      telefono: data.c_phone ?? directionUsa.telefono,
    },
  };
}
